import { render, staticRenderFns } from "./CopyrightFormsEscalated.vue?vue&type=template&id=75a3685f&scoped=true&"
import script from "./CopyrightFormsEscalated.vue?vue&type=script&lang=js&"
export * from "./CopyrightFormsEscalated.vue?vue&type=script&lang=js&"
import style0 from "./CopyrightFormsEscalated.vue?vue&type=style&index=0&id=75a3685f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75a3685f",
  null
  
)

export default component.exports